import React, { useState } from 'react'
import { UserIcon, LockClosedIcon } from '@heroicons/react/24/outline'
import LoginModal from '../login-modal'

const PriorityBookingLoginPrompt = ({ eventName, onLoginSuccess }) => {
  const [showLoginModal, setShowLoginModal] = useState(false)

  const handleLoginSuccess = (user) => {
    setShowLoginModal(false)
    if (onLoginSuccess) {
      onLoginSuccess(user)
    }
  }

  return (
    <>
      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-6">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <LockClosedIcon className="w-6 h-6 text-blue-600 dark:text-blue-400" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-medium text-blue-900 dark:text-blue-100 mb-2">
              Priority Booking Available
            </h3>
            <p className="text-blue-700 dark:text-blue-300 mb-4">
              This event is currently in priority booking. Sign in to your account to check if you're eligible to book early.
            </p>
            <button
              onClick={() => setShowLoginModal(true)}
              className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors"
            >
              <UserIcon className="w-4 h-4 mr-2" />
              Sign In to Book
            </button>
          </div>
        </div>
      </div>

      <LoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
        onLoginSuccess={handleLoginSuccess}
      />
    </>
  )
}

export default PriorityBookingLoginPrompt